import "./SearchUnitTool.scss";
// REACT, ROUTER, REDUX
import React, { useEffect, useRef, useState } from "react";

// COMPONENTS & FUNCTIONS
import * as calculators from "../../engineering/calculators";
import * as advancedCalculators from "../../engineering/advanced-calculators";
import useOutsideClick from "../../functions/useOutsideClick";

// NPM INSTALLS
import * as FaIcons from "react-icons/fa";

// INTERFACES
import { SearchUnitProps } from "../../interface/propTypesInterface";
import { AppData } from "../../interface/functionalityInterface";

const listofCalcs = Object.entries(calculators)
  .map((entry) => entry[1])
  .filter((unit) => unit.type === AppData.CALCULATOR)
  .map((calc) => calc.name);
const listOfAdvancedCalculators = Object.entries(advancedCalculators)
  .map((entry) => entry[1])
  .filter((unit) => unit.type === AppData.ADVANCED_CALCULATOR)
  .map((calc) => calc.name);
const listOfConverters = Object.entries(calculators)
  .map((entry) => entry[1])
  .filter((unit) => unit.type === AppData.CONVERTER)
  .map((converter) => converter.name);
const allUnits = {
  other: listOfConverters,
  calculators: listofCalcs,
  advancedCalculators: listOfAdvancedCalculators,
};
// const allUnits = [...listofCalcs, "chart"];

export default function SearchUnitTool(props: SearchUnitProps) {
  // :::: CONSTANTS :::::
  const elemID = "search-calc-tool";
  const { callback } = props;
  //  ::::: STATES :::::
  const [units, setUnits] = useState<{
    other: string[];
    calculators: string[];
    advancedCalculators: string[];
  }>(allUnits);
  const [show, setshow] = useState(false);
  const [elem, setelem] = useState<HTMLElement | null>();

  // ::::: USEHOOKS :::::

  useEffect(() => {
    setelem(document.getElementById(elemID));
  }, []);
  useEffect(() => {
    if (show) {
      document.documentElement.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyPress);
    } else {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    }
    return () => {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [show]);

  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, () => {
    if (!show) return;
    handleExit();
  });

  // ::::: HANDLER FUNCTIONS :::::

  const handleFormatSearchList = (unitList: string[]) => {
    const calcList = unitList.filter(
      (unit) => unit !== "converter" && unit !== "chart"
    );
    return ["coverter", ...calcList];
  };

  const handleSelectUnit = (unit: string) => {
    callback(unit);
    setshow(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filterOther = allUnits.other.filter((unit) =>
      unit.toUpperCase().includes(e.target.value.toUpperCase())
    );
    const filterCalculators = allUnits.calculators.filter((unit) =>
      unit.toUpperCase().includes(e.target.value.toUpperCase())
    );
    const filterAdvancedCalculators = allUnits.advancedCalculators.filter(
      (unit) => unit.toUpperCase().includes(e.target.value.toUpperCase())
    );
    setUnits({
      other: filterOther,
      calculators: filterCalculators,
      advancedCalculators: filterAdvancedCalculators,
    });
  };

  const handleExit = () => {
    elem?.classList.remove("visible");
    setshow(false);
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      setshow(false);
    }
  };
  const otherItems = units?.other.map((unit, index) => {
    return (
      <li key={`${unit}-${index}`} onClick={() => handleSelectUnit(unit)}>
        <p>{unit}</p>
      </li>
    );
  });
  const calcItems = units?.calculators.map((unit, index) => {
    return (
      <li key={`${unit}-${index}`} onClick={() => handleSelectUnit(unit)}>
        <p>{unit}</p>
      </li>
    );
  });
  const advancedCalcItems = units?.advancedCalculators.map((unit, index) => {
    return (
      <li key={`${unit}-${index}`} onClick={() => handleSelectUnit(unit)}>
        <p>{unit}</p>
      </li>
    );
  });

  // ::::: JSX :::::
  return (
    <div className="searchunit" ref={ref}>
      <button
        id="search-unit-button"
        onClick={() => {
          setshow(true);
        }}
        className="rectangular-button translateY"
        type="button"
      >
        <FaIcons.FaPlus />
        <span>add unit</span>
      </button>
      <aside id={elemID} className={show ? "popup visible" : "popup"}>
        <button
          className="close-button"
          type="button"
          onClick={handleExit}
          style={{ position: "absolute" }}
          tabIndex={show ? 0 : -1}
        ></button>
        <h4 className="searchunit__header u-flex-center">Search Units</h4>
        <input
          placeholder="Type here to search for units!"
          onChange={handleChange}
          type="text"
          tabIndex={show ? 0 : -1}
        />
        <ul>
          {otherItems.length > 0 && (
            <h6
              style={{
                textAlign: "start",
                marginLeft: "1.8rem",
                marginTop: ".4rem",
                textDecoration: "underline",
              }}
            >
              other
            </h6>
          )}
          {otherItems}
          {calcItems.length > 0 && (
            <h6
              style={{
                textAlign: "start",
                marginLeft: "1.8rem",
                marginTop: ".4rem",
                textDecoration: "underline",
              }}
            >
              calculators
            </h6>
          )}
          {calcItems}
          {advancedCalcItems.length > 0 && (
            <h6
              style={{
                textAlign: "start",
                marginLeft: "1.8rem",
                marginTop: ".4rem",
                textDecoration: "underline",
              }}
            >
              advanced calculators
            </h6>
          )}
          {advancedCalcItems}
        </ul>
      </aside>
    </div>
  );
}
